import React from 'react';
import SellerInfoBlock from '../seller-info-block/seller-info-block';

const SellerContactCard: React.FC<Props> = ({ isMobileCardsLayout }) => {
    return <SellerInfoBlock isMobileCardsLayout={isMobileCardsLayout} />;
};

interface Props {
    isMobileCardsLayout: boolean;
}

export default SellerContactCard;
